export const datalayerPush = (data?: Record<string, unknown> | string) => {
    if (!window?.dataLayer) return;

    if (typeof data === "string") {
        window.dataLayer.push({ event: data });
    } else {
        window.dataLayer.push({ ...data });
    }
};
